import React, { useEffect, useRef, useState } from "react";

const CustomSelect = ({
  options,
  selectedValue,
  onChange,
  disabled = false,
  placeholder,
  className,
  icon,
  width,
}) => {
  //  console.log({placeholder,disabled})
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Find selected option based on value
  const selectedOption = options.find(
    (option) => option.value === selectedValue
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`${disabled?'disabled':''} custom-select-wrapper `} ref={selectRef}>
      <div
        className={`${disabled?'disabled':''} custom-select ${className || ""}`}
        onClick={toggleDropdown}
      >
        <span>
          {" "}
          {icon && icon}
          {selectedOption ? selectedOption.label : placeholder}
          {icon && (
            <img
              src="/images/chevron-down-dark.svg"
              alt="icon down"
              className="ml-8"
            />
          )}
        </span>
        {!icon && <span className="select-icon"></span>}{" "}
        {/* Empty span for the icon */}
        {/* <img src="/images/chevron-down.svg" alt="chevron down icon" className="ml-8 select-icon" /> */}
      </div>

      {isOpen && !disabled && (
        <div className={` custom-options`} style={{ width: width }}>
          {options.map((option) => (
            <div
              key={option.value}
              className="custom-option"
              onClick={() => {
                onChange(option.value); // Ensure only the value is passed
                setIsOpen(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
